import { FavoriteDiagnosisComposite } from "./FavoriteDiagnosisComposite";

class DiagnosisModel {
    public IsLoading: boolean;
    public IsInEditMode: boolean;

    public Model: FavoriteDiagnosisComposite;
    public DiagnosisTab_OriginalDiagnose: DiagnosisModel;

    constructor(model: FavoriteDiagnosisComposite, isLoading: boolean = false) {
        this.IsLoading = isLoading;
        this.IsInEditMode = true;
        this.Model = model;
    }

    public GetName(): string {
        const items = this.Model.DiagnosisItems;

        let name = "";
        for (let element of items)
            name += `${element.Code} ${element.Text}`;

        return name;
    }
}

export { DiagnosisModel };
